export function isValidUrl (value) {
  try {
    const url = new URL(value)
    return ['http:', 'https:'].includes(url.protocol) || 'Must be a valid http/https URL'
  } catch {
    return 'Must be a valid URL'
  }
}
